//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

	name: "latte-widget-note",

	data()
	{
		return {
			colors: [
				{rgb: [255, 205, 210], name: "Rood"},
				{rgb: [248, 187, 208], name: "Roze"},
				{rgb: [225, 190, 231], name: "Paars"},
				{rgb: [209, 196, 233], name: "Donkerpaars"},
				{rgb: [197, 202, 233], name: "Indigo"},
				{rgb: [187, 222, 251], name: "Blauw"},
				{rgb: [179, 229, 252], name: "Lichtblauw"},
				{rgb: [178, 235, 242], name: "Cyaan"},
				{rgb: [178, 223, 219], name: "Teal"},
				{rgb: [200, 230, 201], name: "Groen"},
				{rgb: [220, 237, 200], name: "Lichtgroen"},
				{rgb: [240, 244, 195], name: "Limoen"},
				{rgb: [255, 249, 196], name: "Geel"},
				{rgb: [255, 236, 179], name: "Amber"},
				{rgb: [255, 224, 178], name: "Oranje"},
				{rgb: [255, 204, 188], name: "Donkeroranje"},
				{rgb: [215, 204, 200], name: "Bruin"},
				{rgb: [255, 255, 255], name: "Wit"}
			],
			widgetData: undefined
		};
	},

	computed: {

		baseStyles()
		{
			if (!this.widgetData)
				return undefined;

			return {
				"--panel-background": this.colors[this.widgetData.color].rgb.join(", ")
			};
		}

	},

	methods: {

		onWidgetReady({data})
		{
			this.widgetData = data;
		}

	}

}

